export enum MIME_TYPES {
  jpg = 'image/jpeg',
  pjpg = 'image/pjpeg',
  gif = 'image/gif',
  png = 'image/png',
  bmp = 'image/bmp',
  tiff = 'image/tiff',
  txt = 'text/plain',
  csv = 'text/comma-separated-values',
  xls = 'application/msexcel',
  xlsx = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  doc = 'application/msword',
  docx = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  pdf = 'application/pdf',
  svg = 'image/svg+xml'
}
